import { createSlice } from '@reduxjs/toolkit'
import { AvailableRevisions, Revision } from 'redux-store/models'
import { Payload, ReduxRootState } from 'types'

interface State {
  currentRevision: null | Revision
  isCurrentRevisionLoading: boolean
  availableRevisions: null | AvailableRevisions
}

const initialState: State = {
  currentRevision: null,
  isCurrentRevisionLoading: false,
  availableRevisions: null,
}

export const currentPracticeSlice = createSlice({
  name: 'currentPractice',
  initialState,
  reducers: {
    setCurrentRevision: (state, { payload }: Payload<null | Revision>) => {
      state.currentRevision = payload
    },
    setCurrentRevisionLoading: (state, { payload }: Payload<boolean>) => {
      state.isCurrentRevisionLoading = payload
    },
    setAvailableRevisions: (
      state,
      { payload }: Payload<AvailableRevisions>
    ) => {
      state.availableRevisions = { ...state.availableRevisions, ...payload }
    },
  },
})

export const {
  setCurrentRevision,
  setCurrentRevisionLoading,
  setAvailableRevisions,
} = currentPracticeSlice.actions

export const currentPracticeReducer = currentPracticeSlice.reducer

export const selectCurrentRevision = (state: ReduxRootState) =>
  state.currentPractice.currentRevision

export const selectIsCurrentRevisionLoading = (state: ReduxRootState) =>
  state.currentPractice.isCurrentRevisionLoading

export const selectAvailableRevisions = (state: ReduxRootState) =>
  state.currentPractice.availableRevisions
